<div style="text-align:center; width:100%;">
    <span  [innerHTML]="data.title"></span>
    <button mat-raised-button class="snackbarButton" (click)="snackBar.dismiss()">X</button>
</div>
<hr>
<div [innerHTML]="data.html"></div>
<div class="close-slider">
    <div class="timed-slider" [style.width]="[remainingPercent] + '%'"></div>
</div>